import { render, staticRenderFns } from "./Ftp.vue?vue&type=template&id=2c19c372&"
import script from "./Ftp.vue?vue&type=script&lang=js&"
export * from "./Ftp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports